module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-panoramic-view.0dd2c66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-panoramic-view.svg
// module id = 1790
// module chunks = 1